/**
 * Brief transition card rendered by <ServiceGate> when the SPA has
 * detected a helper restart (see useRuntimeConfig.fetchOnce —
 * `pendingHelperRestartReload`) and is about to call
 * `window.location.reload()` to pick up the freshly-built bundle.
 *
 * The reset → reload window is typically 30-80 ms (one microtask for
 * the `await resetServiceWorkerAndCaches()` + browser nav). React will
 * usually render this card for at most one frame. That's deliberately
 * minimal — long enough that the user doesn't see a momentary flash
 * of the main UI, short enough that they don't read it as "loading
 * spinner that never ends".
 *
 * Visual language matches the LocalService offline panel: same card
 * chrome, same accent color, but the icon and copy are tuned for the
 * "helpful interim" mood rather than the "actionable error" one.
 */
import { Loader2 } from 'lucide-react';

export function ReloadingScreen(): JSX.Element {
  return (
    <div className="flex h-full w-full items-center justify-center bg-bg p-6 text-ink">
      <div className="w-full max-w-md rounded-xl border border-line bg-bg-card p-6 shadow-card">
        <div className="flex items-start gap-3">
          <div className="rounded-lg bg-accent/10 p-2.5">
            <Loader2 className="h-5 w-5 animate-spin text-accent" />
          </div>
          <div className="min-w-0 flex-1">
            <h1 className="text-base font-semibold text-ink">本地服务已更新</h1>
            <p className="mt-1.5 text-xs leading-relaxed text-ink-muted">
              正在加载最新版本，请稍候…
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
